import { gql } from 'graphql-request';

export const FETCH_MOVIE_BY_ACTORS = gql`
  query moviesByActors_webApp($filter: MovieByActorsFilter!) {
    moviesByActors(filter: $filter) {
      __typename
      title
      contents {
        ... on Movie {
          id
          title
          originalTitle
          duration
          businessType
          genres {
            id
            value
          }
          languages
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
          tags
          tier
          seoTitle
          slug
        }
      }
    }
  }
`;
